import { render, staticRenderFns } from "./rectangle-a4.vue?vue&type=template&id=4c304f3c"
import script from "./rectangle-a4.vue?vue&type=script&lang=js"
export * from "./rectangle-a4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports